import AmexShopSmallSpendAndGet from './AmexShopSmallSpendAndGet';

export default AmexShopSmallSpendAndGet;
